import React from 'react'
import { spacing } from '@mobi/component-library/Foundations'
import { InfoHeader } from '@mobi/component-library/Typography/InfoHeader'

export const SearchErrored = () => {
  return (
    <div style={{ paddingTop: spacing.lg }}>
      <InfoHeader
        size='large'
        icon='error'
        header='An Error has Occurred'
        subHeader='Please try again'
      />
    </div>
  )
}
